export default {"src":"/_next/static/media/fUsdc.7410c318.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};